import './index.css';

const index = () => {
	return (
		<div>
			<div className="footer">
				<div className="container footer-flex">
					<p>&copy; Demo built by Minh Tu</p>
					<p><a href="https://github.com/minhtu-nguyen">GitHub</a></p>
				</div>
			</div>
		</div>
	);
};

export default index;
